import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RvReportComponent } from './rv-report.component';
import { DateTimeModule} from '../../../common/component/date-time/date-time.module';
import { Routes, RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { ConfigurableLinkListComponent } from '../../../common/component/configurable_link_list/configurable_link_list.component';
import { ConfigurableLinkListModule } from '../../../common/component/configurable_link_list/configurable_link_list.module';
import { SpinnerModule } from '../../../common/component/spinner/spinner.module';

import { AlertComponent } from '../../../common/component/alert/alert.component';
import { AlertModule } from '../../../common/component/alert/alert.module';
import { ConfirmDialogModule } from '../../../common/component/confirm-dialog/confirm-dialog.module';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,DropDownsModule
    ,GridModule
    ,DateTimeModule
    ,RouterModule
    ,ConfigurableLinkListModule
    ,SpinnerModule
    ,AlertModule
    ,ConfirmDialogModule
  ],
  declarations: [RvReportComponent],
  exports: [RvReportComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RvReportModule {}
